var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8571 8.54237C17.8571 10.5762 16.6046 13.0955 15.2381 15.8644C13.4346 19.5186 11.2771 23.3057 9.99996 24C8.68987 23.0504 6.58089 19.5515 4.76187 15.8644C3.46393 13.2336 2.14282 10.5069 2.14282 8.54237C2.14282 3.82455 5.66058 0 9.99996 0C14.3393 0 17.8571 3.82455 17.8571 8.54237Z",
    fill: "#3967BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8571 8.54237C17.8571 10.5762 16.6046 13.0955 15.2381 15.8644C13.4346 19.5186 11.2771 23.3057 9.99996 24C8.68987 23.0504 6.58089 19.5515 4.76187 15.8644C3.46393 13.2336 2.14282 10.5069 2.14282 8.54237C2.14282 3.82455 5.66058 0 9.99996 0C14.3393 0 17.8571 3.82455 17.8571 8.54237Z",
    fill: "#3967BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2847 9.88235C19.2847 14.9372 15.1358 19.0494 10 19.0494C4.86419 19.0494 0.715289 14.9372 0.715289 9.88235C0.715289 4.82748 4.86419 0.715289 10 0.715289C15.1358 0.715289 19.2847 4.82748 19.2847 9.88235Z",
    fill: "white",
    stroke: "#3967BF",
    strokeWidth: 1.43058
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2847 9.88235C19.2847 14.9372 15.1358 19.0494 10 19.0494C4.86419 19.0494 0.715289 14.9372 0.715289 9.88235C0.715289 4.82748 4.86419 0.715289 10 0.715289C15.1358 0.715289 19.2847 4.82748 19.2847 9.88235Z",
    fill: "white",
    stroke: "#3967BF",
    strokeWidth: 1.43058
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1229_355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.91667 13.5883V9.71772C7.91667 9.48709 7.91667 9.3718 7.96208 9.28372C8.00203 9.20623 8.06577 9.14323 8.14417 9.10378C8.2333 9.05888 8.34998 9.05888 8.58333 9.05888H11.4167C11.65 9.05888 11.7667 9.05888 11.8558 9.10378C11.9342 9.14323 11.998 9.20623 12.0379 9.28372C12.0833 9.3718 12.0833 9.48709 12.0833 9.71772V13.5883M9.16667 10.706H10.8333M9.16667 12.353H10.8333M6.25 9.25988V12.9295C6.25 13.1601 6.25 13.2754 6.29541 13.3635C6.33536 13.4409 6.3991 13.5039 6.4775 13.5434C6.56663 13.5883 6.68331 13.5883 6.91667 13.5883H13.0833C13.3167 13.5883 13.4334 13.5883 13.5225 13.5434C13.6009 13.5039 13.6646 13.4409 13.7046 13.3635C13.75 13.2754 13.75 13.1601 13.75 12.9295V9.25988C13.75 8.81775 13.75 8.59668 13.682 8.40137C13.6219 8.22866 13.5237 8.07127 13.3947 7.94054C13.2487 7.79271 13.0489 7.69331 12.6493 7.4945L10.8993 6.62391C10.5696 6.45992 10.4048 6.37792 10.2318 6.34565C10.0786 6.31707 9.92137 6.31707 9.76817 6.34565C9.59517 6.37792 9.43037 6.45991 9.10071 6.62391L7.35071 7.4945C6.95108 7.69331 6.75127 7.79271 6.60531 7.94054C6.47624 8.07127 6.37811 8.22866 6.31799 8.40137C6.25 8.59668 6.25 8.81775 6.25 9.25988Z",
    stroke: "#3967BF",
    strokeWidth: 0.894111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1229_355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 9.88235,
    fill: "white",
    transform: "translate(5 4.94141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage);
export default __webpack_public_path__ + "static/media/storage.5ea9930147a3684f8d67083c300c53f2.svg";
export { ForwardRef as ReactComponent };